<template>
  <v-list :class="loadingUsers ? 'text-center pt-0' : 'pt-0'">
    <template v-if="loadingUsers">
      <v-progress-circular indeterminate width="1" size="25" />
    </template>
    <template v-else>
      <v-list-item
        v-for="(id, index) in useUserIds"
        :key="id"
        @mouseover="hoveredIndex = index"
        @mouseleave="hoveredIndex = null"
      >
        <template #prepend>
          <v-avatar v-if="id in users" variant="outlined" size="22">
            {{ users[id].display_name[0].toUpperCase() }}
          </v-avatar>
        </template>
        <v-list-item-title v-if="id in users">
          {{ id in users ? users[id].display_name : 'User not found' }}
        </v-list-item-title>
        <v-list-item-subtitle v-if="id in users">
          {{ users[id].email }}
        </v-list-item-subtitle>
        <template #append v-if="(userIsWorkspaceOwner || userIsSelf(id)) && showActions">
          <v-btn
            :variant="userIsWorkspaceOwner ? 'text' : 'outlined'"
            :icon="userIsWorkspaceOwner"
            size="small"
            @click="handleRemoveClick(users[id])"
            color="red"
          >
            <v-icon v-if="userIsWorkspaceOwner"> mdi-close-circle-outline </v-icon>
            <span v-if="!userIsWorkspaceOwner">
              {{ $t('workspaces.text.leave') }}
            </span>
          </v-btn>
        </template>
      </v-list-item>
    </template>
    <confirm-dialog
      key="confirmDialogUserLeave"
      ref="confirmDialogUserLeave"
      :message="confirmDialogText.message"
      :action-text="confirmDialogText.actionText"
      :danger-button="true"
    />
  </v-list>
</template>

<script>
import { useFirestoreUsers } from '@/composables/users/useFirestoreUsers'
import { useAuthStore } from '@/store/auth'
import { mapStores } from 'pinia'
import ConfirmDialog from '@/components//nav/ConfirmDialog.vue'
import { log } from '@/plugins/logger'

export default {
  name: 'UserList',
  components: {
    ConfirmDialog
  },
  props: {
    userIds: {
      type: Array,
      required: true
    },

    userIsWorkspaceOwner: {
      type: Boolean,
      default: false
    },
    showActions: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const { users, loadingUsers, getUsersByIds } = useFirestoreUsers()
    return {
      users,
      loadingUsers,
      getUsersByIds
    }
  },
  data() {
    return {
      hoveredIndex: null
    }
  },
  computed: {
    ...mapStores(useAuthStore),

    useUserIds() {
      return this.userIds.filter(id => this.users[id])
    },

    neededUsers() {
      // return users that are in userIds but not a key in users
      return this.userIds.filter(id => !this.users[id])
    },
    numNeededUsers() {
      return this.neededUsers.length
    },
    confirmDialogText() {
      return {
        message: this.$t('workspaces.text.confirmLeaveWorkspace'),
        actionText: this.$t('workspaces.buttons.leaveWorkspace')
      }
    }
  },
  watch: {
    async numNeededUsers() {
      if (this.neededUsers.length > 0) {
        await this.getUsersByIds(this.neededUsers)
      }
    }
  },

  methods: {
    userIsSelf(id) {
      return id === this.authStore.userData.uid
    },
    async handleRemoveClick(user) {
      if (this.userIsWorkspaceOwner) {
        this.$emit('user-close-clicked', user)
      } else {
        let proceed = await this.$refs.confirmDialogUserLeave.show()
        if (proceed) {
          this.$emit('user-leave-workspace', user)
        }
      }
    }
  },

  mounted() {
    if (this.numNeededUsers) {
      this.getUsersByIds(this.neededUsers)
    }
  }
}
</script>
